import React from 'react';
import { getFormValues, reduxForm, SubmissionError } from 'redux-form';
import Field from 'src/ConnectedComponents/fields/Field';
import { Link } from 'react-router-dom';
import { replace } from 'react-router-redux';
import { connect } from 'react-redux';

import { postHandler } from 'src/utils/fetchHandler';
import { getAuthHost } from 'src/utils/getAuthHost';
import Logo from 'src/ConnectedComponents/utils/Logo';
import styles from './index.css';
import { FlexBox, ShadowBox, Box, Text, Button } from 'src/lib/StyledComponents';

const authenticationPath = 'authentication';

let Login = ({ handleSubmit, error, formValues = {} }) => (
	<form onSubmit={handleSubmit} className={styles.Login}>
		<Logo />
		<Text className={styles.Quote}>
			“A small group of thoughtful, committed citizens can change the world; indeed, it’s the
			only thing that ever has.”
			<br /> <strong>- Margaret Mead</strong>
		</Text>
		<ShadowBox className={styles.LoginPanel}>
			<Text className={styles.Title}>Login to wisely</Text>
			{error && <Text className={styles.Error}>{error}</Text>}
			<Field name="email" placeholder="Email" component="input" className={styles.Input} />
			<Field
				name="password"
				placeholder="Password"
				component="input"
				type="password"
				className={styles.Input}
				heap-ignore="true"
			/>
			<FlexBox className={styles.ButtonContainer}>
				<Button type="submit" className={styles.SignInButton}>
					Sign in
				</Button>
			</FlexBox>
			<Box className={styles.ForgotPassword}>
				<Link
					to={{
						pathname: 'password_reset',
						state: { email: formValues.email || '' },
					}}
				>
					Reset my password
				</Link>
			</Box>
		</ShadowBox>
	</form>
);

const identifyUser = ({ email }) => {
	if (email) {
		window.analytics.identify(email, {
			email,
		});
	}
};

const onSubmit = async (auth, _dispatch, props) => {
	const body = {
		...auth,
		strategy: 'local',
		...(window.localStorage.login_as ? { login_as: window.localStorage.login_as } : {}),
	};

	return postHandler(authenticationPath, JSON.stringify(body), null, getAuthHost(), true)
		.then(result => {
			const destination = props.location.from || '/';
			window.localStorage.wiselyToken = result.accessToken;
			props.replace(destination);
			identifyUser(body);
		})
		.catch(e => {
			throw new SubmissionError({
				_error: e && e.message ? e.message : e.toString(),
			});
		});
};

Login = reduxForm({
	form: 'login',
	onSubmit,
})(Login);

Login = connect(state => ({ formValues: getFormValues('login')(state) }), { replace })(Login);

export default Login;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Login/index.js